import { motion } from "framer-motion";
import { Trans } from "react-i18next";

import { PlatformLogo } from "@/components/PlatformLogo";
import { ANIMATION_DURATION } from "@/constants/animations.constants";
import { useTranslation } from "@/core/i18n";
import { MobileViewportContainer } from "@/modules/onboarding/components/MobileViewportContainer/MobileViewportContainer";
import { OnboardingHeader } from "@/modules/onboarding/components/OnboardingScreenHeader/OnboardingHeader";
import { Button } from "atoms/button/Button";

import { PersonalisationScreenLayout } from "./PersonalisationScreenLayout";

interface PersonalisationWelcomeScreenProps {
  platformName: string;
  platformLogoUrl?: string;
  userFirstName: string;
  onGetStarted: () => void;
}

export function PersonalisationWelcomeScreen({
  platformName,
  platformLogoUrl,
  userFirstName,
  onGetStarted,
}: PersonalisationWelcomeScreenProps) {
  const { t } = useTranslation();
  return (
    <PersonalisationScreenLayout>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: ANIMATION_DURATION, delay: 0.1 }}
        className="mx-auto flex w-[322px] flex-1 flex-col items-center pt-[50%]"
      >
        <PlatformLogo platformName={platformName} logoUrl={platformLogoUrl} className="mb-16" />

        <OnboardingHeader
          title={
            <Trans
              i18nKey="personalisationWelcomeScreen.title"
              values={{ platformName, userFirstName }}
              components={{ br: <br /> }}
            />
          }
          subtitle={t("personalisationWelcomeScreen.subtitle")}
          className="mb-8"
          titleClassName="!text-[30px] !leading-8 text-center"
          subtitleClassName="mt-4"
        />
        <Button fullWidth onClick={onGetStarted}>
          {t("personalisationWelcomeScreen.getStarted")}
        </Button>
      </motion.div>
    </PersonalisationScreenLayout>
  );
}
